export default __webpack_public_path__ + "static/media/image_arrow.879ee518.svg";